import polyglotI18nProvider from 'ra-i18n-polyglot';
import engMessages from "./en"
import hunMessages from "./hu";

const i18nProvider = polyglotI18nProvider(locale =>
        locale === 'en' ? engMessages : hunMessages,
    'hu' // Default locale
);

export default i18nProvider;